export function getFirebaseDateOrNow(createdAt: any) {
  return createdAt
    ? (createdAt as firebase.firestore.Timestamp).toDate()
    : new Date();
}
